import * as Types from "../constants/Types/AutoTranslate";

const initialState = {
  campaign: {
    isTranslating: false,
    result: null,
    error: null,
  },
  hotel: {
    isTranslating: false,
    result: null,
    error: null,
  },
  tour: {
    isTranslating: false,
    result: null,
    error: null,
  },
  tourTicket: {
    isTranslating: false,
    result: null,
    error: null,
  },
  supplier: {
    isTranslating: false,
    result: null,
    error: null,
  },
  menu: {
    isTranslating: false,
    result: null,
    error: null,
  },
  tagGroupDetail: {
    isTranslating: false,
    result: null,
    error: null,
  },
  vinWonderTagGroup: {
    isTranslating: false,
    result: null,
    error: null,
  },
  rate: {
    isTranslating: false,
    result: null,
    error: null,
  },
  ratePlan: {
    isTranslating: false,
    result: null,
    error: null,
  },
  bookablePackageRate: {
    isTranslating: false,
    result: null,
    error: null,
  },
};

const handleEntityTranslation = (
  state,
  entity,
  action,
  isRequest = false,
  isSuccess = false,
  isFailure = false
) => {
  return {
    ...state,
    [entity]: {
      isTranslating: isRequest,
      result: isRequest
        ? null
        : isSuccess
        ? { success: true }
        : state[entity].result,
      error: isFailure ? action.error : null,
    },
  };
};

const autoTranslateReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.CAMPAIGN_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "campaign",
        action,
        true,
        false,
        false
      );

    case Types.CAMPAIGN_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "campaign",
        action,
        false,
        true,
        false
      );

    case Types.CAMPAIGN_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "campaign",
        action,
        false,
        false,
        true
      );

    case Types.HOTEL_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "hotel",
        action,
        true,
        false,
        false
      );

    case Types.HOTEL_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "hotel",
        action,
        false,
        true,
        false
      );

    case Types.HOTEL_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "hotel",
        action,
        false,
        false,
        true
      );

    case Types.ROOM_TYPE_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "hotel",
        action,
        true,
        false,
        false
      );

    case Types.ROOM_TYPE_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "hotel",
        action,
        false,
        true,
        false
      );

    case Types.ROOM_TYPE_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "hotel",
        action,
        false,
        false,
        true
      );

    case Types.TOUR_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(state, "tour", action, true, false, false);

    case Types.TOUR_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(state, "tour", action, false, true, false);

    case Types.TOUR_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(state, "tour", action, false, false, true);

    case Types.TOUR_TICKET_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "tourTicket",
        action,
        true,
        false,
        false
      );

    case Types.TOUR_TICKET_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "tourTicket",
        action,
        false,
        true,
        false
      );

    case Types.TOUR_TICKET_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "tourTicket",
        action,
        false,
        false,
        true
      );

    case Types.SUPPLIER_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "supplier",
        action,
        true,
        false,
        false
      );

    case Types.SUPPLIER_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "supplier",
        action,
        false,
        true,
        false
      );

    case Types.SUPPLIER_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "supplier",
        action,
        false,
        false,
        true
      );

    case Types.MENU_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "menu",
        action,
        true,
        false,
        false
      );

    case Types.MENU_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "menu",
        action,
        false,
        true,
        false
      );

    case Types.MENU_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "menu",
        action,
        false,
        false,
        true
      );

    case Types.TAG_GROUP_DETAIL_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "tagGroupDetail",
        action,
        true,
        false,
        false
      );

    case Types.TAG_GROUP_DETAIL_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "tagGroupDetail",
        action,
        false,
        true,
        false
      );

    case Types.TAG_GROUP_DETAIL_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "tagGroupDetail",
        action,
        false,
        false,
        true
      );

    case Types.VINWONDER_TAG_GROUP_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "vinWonderTagGroup",
        action,
        true,
        false,
        false
      );

    case Types.VINWONDER_TAG_GROUP_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "vinWonderTagGroup",
        action,
        false,
        true,
        false
      );

    case Types.VINWONDER_TAG_GROUP_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "vinWonderTagGroup",
        action,
        false,
        false,
        true
      );

    case Types.RATE_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(state, "rate", action, true, false, false);

    case Types.RATE_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(state, "rate", action, false, true, false);

    case Types.RATE_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(state, "rate", action, false, false, true);

    case Types.RATE_PLAN_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "ratePlan",
        action,
        true,
        false,
        false
      );

    case Types.RATE_PLAN_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "ratePlan",
        action,
        false,
        true,
        false
      );

    case Types.RATE_PLAN_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "ratePlan",
        action,
        false,
        false,
        true
      );

    case Types.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_REQUEST:
      return handleEntityTranslation(
        state,
        "bookablePackageRate",
        action,
        true,
        false,
        false
      );

    case Types.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_SUCCESS:
      return handleEntityTranslation(
        state,
        "bookablePackageRate",
        action,
        false,
        true,
        false
      );

    case Types.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_FAILURE:
      return handleEntityTranslation(
        state,
        "bookablePackageRate",
        action,
        false,
        false,
        true
      );

    default:
      return state;
  }
};

export default autoTranslateReducer;
